import React, { useEffect, useState } from "react";
import { FormValidator, Inputs } from "coaz-ui";
import client from "../client";
import LoadingIcons from "react-loading-icons";
import UserItems from "./UserItems";

const AddProgramStudent = ({ params, submitRef, setLoading, setEnableSubmit }) => {
  const programId = params ? params.programId : null;

  const [program, setProgram] = useState(null);
  const [programLoaded, setProgramLoaded] = useState(false); 
  const [user, setUser] = useState(null); 
  const { request, errorMessage } = client;

  const userName = user
    ? `${user.firstname ?? ""} ${user.lastname ?? ""}`.trim() || user.name || ""
    : "";

  const submit = async () => {
    const userId = user?.ref?.id ?? user?.id;
    if (!userId || !programId) {
      return { message: "Please pick a user first." };
    }

    try {
      await request("POST", "enrollment", null, {
        userId: userId,
        programId: programId,
      });
      return { message: "Successful", success: true };
    } catch (error) {
      return { message: errorMessage(error) };
    }
  };

  useEffect(() => {
    submitRef.current = { submit };
    setEnableSubmit(!!user);

    return () => {
      submitRef.current = null;
    };
  }, [user]);

  useEffect(() => {
    (async () => {
      if (!programId) return;
      setLoading && setLoading(true);
      try {
        const response = await request("GET", `programs/${programId}`);
        if (response && response.ref) setProgram(response);
      } catch (error) {
        console.log(error);
      }
      setProgramLoaded(true);
      setLoading && setLoading(false);
    })();
  }, [programId]);

  const searchUsers = async (searchKey, page) => {
    const categories = program?.professionalCategories ?? [];
    const filters = categories.length > 0 ? categories : [null];

    const fetchFor = async (category) => {
      const query = {
        searchKey: searchKey,
        pageNo: page.pageNo,
        pageSize: page.pageSize,
      };
      if (category) query.professionalCategory = category;

      try {
        return await request("GET", "users/filter-page", null, query, false, "auth/api");
      } catch (error) {
        console.log(error);
        return null;
      }
    };

    const responses = (await Promise.all(filters.map(fetchFor))).filter(Boolean);
    if (responses.length === 0) return null;

    if (responses.length === 1) return responses[0];

    return {
      content: responses.flatMap((response) => response.content ?? []),
      number: page.pageNo,
      size: page.pageSize * filters.length,
      totalElements: responses.reduce((sum, r) => sum + (r.totalElements ?? 0), 0),
      totalPages: Math.max(...responses.map((r) => r.totalPages ?? 1)),
      last: responses.every((r) => r.last ?? true),
    };
  };

  const inputs = [
    {
      label: "Program",
      type: "text",
      name: "program",
      value: program && program.name ? program.name : "",
      disabled: true,
      placeholder: "Program...",
    },
    {
      label: "User",
      type: "text",
      name: "user",
      value: userName,
      disabled: true,
      placeholder: "Pick a user below...",
    },
  ];

  const categories = program?.professionalCategories ?? [];

  return (
    <FormValidator>
      <div className="flex flex-col w-full h-auto space-y-4">
        <Inputs inputs={inputs} minWidth={240} />
        {!programLoaded && (
          <div className="flex items-center justify-center w-full">
            <LoadingIcons.SpinningCircles width={48} height={48} fill="rgb(0,175,240)" />
          </div>
        )}
        {programLoaded && !program && (
          <p className="text-sm text-[rgb(68,71,70)]">The program could not be loaded.</p>
        )}

        {/* {program && (
          <p className="text-xs text-[rgb(145,145,145)]">
            {categories.length > 0
              ? `Showing users in: ${categories.join(", ")}`
              : "This program has no professional category, so all users are shown."}
          </p>
        )} */}

        {program && (
          <UserItems
            search={searchUsers}
            onSelect={setUser}
            selectedId={user ? user.ref?.id ?? user.id : null}
          />
        )}
      </div>
    </FormValidator>
  );
};

export default AddProgramStudent;